import { createClient } from '@supabase/supabase-js';

// Food DB project (separate Supabase project) — read-only source of truth for
// aggregator funnel + metrics. Cron job runs every 30 min, parses Swiggy /
// Zomato / Famepilot exports into flax_metrics_daily.
const url = import.meta.env.VITE_SUPABASE_FOODDB_URL;
const key = import.meta.env.VITE_SUPABASE_FOODDB_ANON_KEY;

if (!url || !key) {
  console.warn('[supabase/fooddb] missing env — aggregator module will show empty state');
}

export const fooddb = createClient(url ?? 'http://localhost', key ?? 'anon', {
  auth: { persistSession: false },
});

/** Food DB outlet slug → marketing.outlets.id slug. */
export const FOODDB_TO_OUTLET: Record<string, string> = {
  lower_parel: 'lower-parel',
  powai: 'powai',
  bandra_khar: 'bandra',
  breach_candy: 'breach-candy',
  andheri_west: 'andheri',
  malad: 'malad',
  fort: 'kalaghoda',
  santacruz_kalina: 'kalina',
  indiranagar: 'indiranagar',
  andheri_east: 'marol',
};

export const OUTLET_TO_FOODDB: Record<string, string> = Object.fromEntries(
  Object.entries(FOODDB_TO_OUTLET).map(([k, v]) => [v, k]),
);

export type AggregatorProvider = 'swiggy' | 'zomato';
